import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentsListTabModule } from '../payments-list-tab/payments-list-tab.module';
import { PaymentsPaymentDetailDialogComponent, PaymentsPaymentDetailDialogService } from './payments-payment-detail-dialog.component';

@NgModule({
  declarations: [PaymentsPaymentDetailDialogComponent],
  imports: [CommonModule, PaymentsListTabModule],
  providers: [PaymentsPaymentDetailDialogService],
  exports: [PaymentsPaymentDetailDialogComponent],
})
export class PaymentsPaymentDetailDialogModule {}
